import { Dispatch, FC, useState } from 'react'
import { Link } from 'react-router-dom';
import {
    Divider, FormControl, FormControlLabel, FormLabel, Switch, Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import UserInformation from '../../../types/UserInformation';
import { useDispatch, useSelector } from 'react-redux';
import { loggoutUser } from '../../../redux/actions/logginUser';
import { Reducers } from '../../../redux/reducers';
import axios, { AxiosInstance } from 'axios';
import './Dropdown.css';
import { MAX_MOBILE_WIDTH } from '../../../constants/Constants';
import { downloadManualUserFile } from '../../../utils/utils';
import { AlertType } from '../../../types/AlertType';

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

interface DropdownInfoUserProps {
    screenWidth: number;
    setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
    setAlerteMessage: Dispatch<React.SetStateAction<string>>;
    setAlertType: Dispatch<React.SetStateAction<AlertType>>;
}

const DropdownInfoUser: FC<DropdownInfoUserProps> = ({
    screenWidth,
    setOpenSnack,
    setAlertType,
    setAlerteMessage
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const logger = useSelector<Reducers>((state) => state.logger) as UserInformation;

    const cookies = new Cookies();
    const token: string = cookies.get("jwt");
    const verticalMenu: boolean = cookies.get("menu");

    const http: AxiosInstance = axios.create({
        baseURL: urlBaseApi,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    const [click, setClick] = useState<boolean>(false);

    const handleClick = () => setClick(!click);

    const handleSignOut = async () => {
        http.post('user/logout')
            .then(() => {
                // Remove the redux store
                dispatch(loggoutUser());

                // Remove cookies in navigator cookies (token, ...)
                cookies.remove('jwt', { path: '/' });
                cookies.remove('profil_id', { path: '/' });
                // cookies.remove('menu', { path: '/' });
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                navigate("/sign-in");
            });
    };

    const handleChange = (e: any) => {
        cookies.remove('menu', { path: '/' });
        cookies.set('menu', !verticalMenu, { path: '/' });
        window.location.reload();
    };

    const downloadManual = () => {
        if (logger?.profils?.manual_user) {
            downloadManualUserFile(logger?.profils?.manual_user);
        } else {
            setAlerteMessage("Il n'y a pas encore de manuel d'utilisateur parametré pour votre Profil.");
            setAlertType("warning");
            setOpenSnack(true);
        }
    };

    const userInfo = `${logger?.prenom} ${logger?.name}`;

    return (
        <>
            <ul
                onClick={handleClick}
                className={click ? 'dropdown-menu-user clicked' : 'dropdown-menu-user'}
            >
                <li>
                    <Typography variant="subtitle1" className="dropdown-link-user">
                        {userInfo}
                    </Typography>
                </li>
                <Divider sx={{ color: '#201f1e' }} />
                <li>
                    <Link
                        className="dropdown-link"
                        to="/account"
                        onClick={() => setClick(false)}
                    >
                        Mon profil
                    </Link>
                </li>
                <Divider sx={{ color: '#201f1e' }} />
                <li>
                    <Link
                        className="dropdown-link"
                        to="#"
                        onClick={() => downloadManual()}
                    >
                        Télécharger Manuel Utilisateur
                    </Link>
                </li>
                <Divider sx={{ color: '#201f1e' }} />
                {screenWidth > MAX_MOBILE_WIDTH && (
                    <>
                        <li style={{ paddingLeft: 7 }}>
                            <FormControl component="fieldset" variant="standard">
                                <FormLabel component="legend" sx={{ color: '#fff', fontSize: 14 }}>Disposition menu :</FormLabel>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            defaultChecked
                                            size='small'
                                            sx={{ ml: 0.8 }}
                                            value={verticalMenu}
                                            checked={verticalMenu}
                                            onChange={handleChange}
                                            color="default"
                                        />
                                    }
                                    label={
                                        <Typography variant='caption'>
                                            {verticalMenu ? 'Vertical' : 'Horizontal'}
                                        </Typography>
                                    }
                                />
                            </FormControl>
                        </li>
                        <Divider sx={{ color: '#201f1e' }} />
                    </>
                )}
                <li>
                    <Link
                        className="dropdown-link"
                        to="#"
                        onClick={() => handleSignOut()}
                    >
                        Déconnexion
                    </Link>
                </li>
                <Divider sx={{ color: '#201f1e' }} />
            </ul>
        </>
    );
};

export default DropdownInfoUser;
